import PdpComponent from './PdpComponent';
import '../css/TableContainer.css';
import ProductComponent from './ProductComponent';
import { useNavigation } from '../function/navigation';
import { ProductSize } from './ProductSize';
import { LoadCheck, shouldShowLoadCheck } from './LoadCheck';
import RenderInputOption from '../inputs/RenderInputOption';

export function TableContainer({
  inputs,
  setInputs,
  options,
  setOptions,
  result,
  productState,
  clickTriggeredRef,
}) {
  const { nav } = useNavigation();
  const shouldRenderProductFlowInput =
    nav.productCurrentPage.menu === 'product' &&
    nav.productCurrentPage.tab === 'Flow';

  return (
    <div className="top-table-container">
      {nav.productCurrentPage.menu === 'pdp' && inputs.pdp?.length > 0 && (
        <>
          <PdpComponent
            inputs={inputs}
            setInputs={setInputs}
            options={options}
            result={result}
          />
          <RenderInputOption
            inputs={inputs}
            setInputs={setInputs}
            options={options}
            setOptions={setOptions}
            input_name={'max_angle_center'}
            result={result}
            forceShowAll={true}
          />
        </>
      )}
      {nav.productCurrentPage.menu === 'product' && (
        <>
          <ProductComponent
            inputs={inputs}
            setInputs={setInputs}
            options={options}
            setOptions={setOptions}
            result={result}
            productState={productState}
          />
          {nav.productCurrentPage.tab === 'Size' && (
            <ProductSize
              inputs={inputs}
              setInputs={setInputs}
              result={result}
              clickTriggeredRef={clickTriggeredRef}
            />
          )}
          {nav.productCurrentPage.tab === 'Flow' && (
            <>
              {shouldRenderProductFlowInput && (
                <div className="product-global-inputs">
                  <RenderInputOption
                    inputs={inputs}
                    setInputs={setInputs}
                    options={options}
                    setOptions={setOptions}
                    input_name="product_flow"
                    result={result}
                    forceShowAll={true}
                  />
                </div>
              )}
              {shouldShowLoadCheck(inputs.product_tbh?.length > 0) && (
                <div className="group">
                  <LoadCheck
                    inputs={inputs}
                    options={options}
                    result={result}
                    clickTriggeredRef={clickTriggeredRef}
                  />
                </div>
              )}
            </>
          )}
        </>
      )}
    </div>
  );
}
